// src/components/NavBar.jsx
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaChevronDown } from 'react-icons/fa';
import './NavBar.css';
import logoImg from '../assets/logo1.png';

const items = [
  'Anasayfa',
  'Kurumsal',
  'Eğitimlerimiz',
  'Neden Yeldeğirmeni?',
  `ZEZE’nin Bahçesi`,
  'VIP Kurs',
  'Kariyer',
  'İletişim'
];

const educationItems = [
  { label: 'Anaokulu', route: '/anaokulu' },
  { label: 'İlkokul ve Ortaokul', route: '/ilkokul-ortaokul' },
  { label: 'LGS, YKS ve VIP Kurslar', route: '/dikmen-kurs-lise-yks-vip' },
];

const whyItems = [
  { label: 'Rehberlik', route: '/rehberlik' },
  { label: 'Dil Eğitim Programı', route: '/dil-egitim' },
  { label: 'Atölyelerimiz', route: '/skills-art-sport' },
];

const sectionMap = {
  'Kurumsal': 'about-section',
  'Neden Yeldeğirmeni?': 'why-section',
  'ZEZE’nin Bahçesi': 'zeze-section',
  'İletişim': 'contact-section',
};

const routeMap = {
  'Kariyer': '/kariyer',
  'Anasayfa': '/',
  'Kurumsal': '/kurumsal',
  'ZEZE’nin Bahçesi': '/zeze',
  'İletişim': '/contact',
  'VIP Kurs': '/dikmen-kurs-lise-yks-vip'
};

export default function NavBar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [eduOpen, setEduOpen] = useState(false);
  const [whyOpen, setWhyOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!mobileOpen) {
      setEduOpen(false);
      setWhyOpen(false);
    }
  }, [mobileOpen]);

  const handleLogoClick = () => {
    setMobileOpen(false);
    navigate('/');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleClick = (label) => {
    if (label === 'Eğitimlerimiz') {
      setEduOpen(prev => {
        const next = !prev;
        if (next) setWhyOpen(false);
        return next;
      });
      return;
    }
    if (label === 'Neden Yeldeğirmeni?') {
      setWhyOpen(prev => {
        const next = !prev;
        if (next) setEduOpen(false);
        return next;
      });
      return;
    }

    setMobileOpen(false);
    setEduOpen(false);
    setWhyOpen(false);

    if (routeMap[label]) {
      navigate(routeMap[label]);
      return;
    }

    const secId = sectionMap[label];
    if (secId) {
      const scrollTo = () => {
        const el = document.getElementById(secId);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      };
      if (location.pathname === '/') {
        scrollTo();
      } else {
        navigate('/');
        setTimeout(scrollTo, 200);
      }
      return;
    }

    if (label === 'Anasayfa') {
      navigate('/');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleEduClick = (item) => {
    setMobileOpen(false);
    setEduOpen(false);
    navigate(item.route);
  };

  const handleWhyClick = (item) => {
    setMobileOpen(false);
    setWhyOpen(false);
    navigate(item.route);
  };

  return (
    <nav className="navbar">
      <div className="logo-container" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
        <img src={logoImg} alt="Yeldeğirmeni Logo" className="logo-img" />
      </div>

      <ul className={`nav-links ${mobileOpen ? 'open' : ''}`}>
        {items.map(label => (
          <li
            key={label}
            className={label === 'Eğitimlerimiz' || label === 'Neden Yeldeğirmeni?' ? 'has-dropdown' : ''}
            onMouseEnter={() => {
              if (window.innerWidth > 768) {
                if (label === 'Eğitimlerimiz') setEduOpen(true);
                if (label === 'Neden Yeldeğirmeni?') setWhyOpen(true);
              }
            }}
            onMouseLeave={() => {
              if (window.innerWidth > 768) {
                if (label === 'Eğitimlerimiz') setEduOpen(false);
                if (label === 'Neden Yeldeğirmeni?') setWhyOpen(false);
              }
            }}
          >
            <button onClick={() => handleClick(label)}>
              {label}
              {(label === 'Eğitimlerimiz' || label === 'Neden Yeldeğirmeni?') && (
                <FaChevronDown className="dropdown-icon" />
              )}
            </button>

            {label === 'Eğitimlerimiz' && eduOpen && (
              <ul className="dropdown-menu">
                {educationItems.map(item => (
                  <li key={item.label}>
                    <button onClick={() => handleEduClick(item)}>
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            )}

            {label === 'Neden Yeldeğirmeni?' && whyOpen && (
              <ul className="dropdown-menu">
                {whyItems.map(item => (
                  <li key={item.label}>
                    <button onClick={() => handleWhyClick(item)}>
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>

      <button
        className="hamburger"
        onClick={() => setMobileOpen(o => !o)}
        aria-label="Toggle menu"
      >
        <div /><div /><div />
      </button>
    </nav>
  );
}
